
import { useEffect } from 'react';
import { app } from "@microsoft/teams-js";
import Config from '../../../config';

const SlackPopup = () => {
    useEffect(() => {
        app.initialize().then(() => {
            const rootUrl = `https://slack.com/oauth/v2/authorize?client_id=${Config.SLACK_APP_CLIENT_ID}&scope=app_mentions:read,channels:history,channels:join,channels:read,chat:write,commands,files:read,files:write,groups:history,im:history,im:write,incoming-webhook,mpim:history,reactions:write&user_scope=`;
            window.location.assign(rootUrl)
        })
    }, []);
    return (
        <div className="ms-Fabric">
            <div id="content">
                <p>Redirecting to Azure AD to request permission consent</p>
            </div>
        </div>
    );
};

export default SlackPopup;
